// Screen ID Configuration for Jewelry Inventory Management System
// This file defines all screen IDs and page identifiers used throughout the application

export const SCREEN_IDS = {
  // Authentication & User Management
  AUTHENTICATION: {
    LOGIN: 'AUTH-001',
    REGISTER: 'AUTH-002',
    FORGOT_PASSWORD: 'AUTH-003',
    RESET_PASSWORD: 'AUTH-004',
    PROFILE: 'AUTH-005'
  },

  // Dashboard & Main Navigation
  DASHBOARD: {
    MAIN: 'DASH-001',
    ANALYTICS: 'DASH-002',
    REPORTS_OVERVIEW: 'DASH-003'
  },

  // Inventory Management
  INVENTORY: {
    VIEW_LIST: 'INV-001',
    ADD_ITEM: 'INV-002',
    EDIT_ITEM: 'INV-003',
    PICTURES: 'INV-004',
    VIEW_DETAILS_MODAL: 'INV-001M1',
    EDIT_MODAL: 'INV-001M2',
    DELETE_CONFIRMATION_MODAL: 'INV-001M3',
    UPDATE_CONFIRMATION_MODAL: 'INV-001M4',
    BULK_IMPORT: 'INV-004',
    BULK_EXPORT: 'INV-005'
  },

  // Category Management
  CATEGORIES: {
    MAIN: 'CAT-001',
    ADD_PRODUCT_TYPE: 'CAT-002',
    ADD_JEWELRY_CATEGORY: 'CAT-003',
    EDIT_CATEGORY_MODAL: 'CAT-001M1',
    DELETE_CATEGORY_MODAL: 'CAT-001M2',
    HIERARCHY_VIEW: 'CAT-004',
    INLINE_NEW_CATEGORY: 'CAT-005'
  },

  // Materials Management
  MATERIALS: {
    MAIN: 'MAT-001',
    ADD_MATERIAL: 'MAT-002',
    EDIT_MATERIAL: 'MAT-003',
    VIEW_MATERIAL_MODAL: 'MAT-001M1',
    DELETE_MATERIAL_MODAL: 'MAT-001M2',
    BULK_UPDATE: 'MAT-004'
  },

  // Vendor Management
  VENDORS: {
    MAIN: 'VEN-001',
    ADD_VENDOR: 'VEN-002',
    EDIT_VENDOR: 'VEN-003',
    VIEW_VENDOR_MODAL: 'VEN-001M1',
    DELETE_VENDOR_MODAL: 'VEN-001M2',
    VENDOR_PERFORMANCE: 'VEN-004',
    VENDOR_LEDGER: 'VEN-005',
    ACCOUNTING_SUMMARY: 'VEN-006'
  },

  // Billing & Sales
  BILLING: {
    INDIAN_BILLING: 'BILL-001',
    US_BILLING: 'BILL-002',
    VIEW_BILLS: 'BILL-003',
    EDIT_BILL: 'BILL-004',
    BILL_DETAILS_MODAL: 'BILL-003M1',
    PAYMENT_MODAL: 'BILL-003M2',
    RECEIPT_MODAL: 'BILL-003M3',
    CUSTOMER_SELECTION: 'BILL-005',
    MULTI_ITEM_BILLING: 'BILL-006',
    BILLING_HISTORY: 'BILL-007',
    RETURNS: 'RET-001'
  },

  // Estimates
  ESTIMATES: {
    INR_ESTIMATE: 'EST-001',
    USD_ESTIMATE: 'EST-002',
    VIEW_ESTIMATES: 'EST-003',
    EDIT_ESTIMATE: 'EST-004',
    ESTIMATE_DETAILS_MODAL: 'EST-003M1',
    CONVERT_TO_SALE_MODAL: 'EST-003M2'
  },

  // Customer Management
  CUSTOMERS: {
    LIST: 'CUST-001',
    DETAIL_MODAL: 'CUST-001M1',
    CREATE_MODAL: 'CUST-001M2',
    EDIT_MODAL: 'CUST-001M3'
  },

  // Reports & Analytics
  REPORTS: {
    INVENTORY_REPORT: 'REP-001',
    SOLD_ITEMS_REPORT: 'REP-002',
    FINANCIAL_REPORT: 'REP-003',
    VENDOR_REPORT: 'REP-004',
    CUSTOM_REPORT: 'REP-005',
    EXPORT_MODAL: 'REP-001M1',
    SALES_BY_VENDOR: 'REP-006',
    SALES_BY_ITEM: 'REP-007',
    EXHIBITION_RECONCILIATION: 'REP-008'
  },

  // Administration
  ADMINISTRATION: {
    USER_MANAGEMENT: 'ADM-001',
    PERMISSIONS: 'ADM-002',
    SYSTEM_SETTINGS: 'ADM-003',
    BACKUP_RESTORE: 'ADM-004',
    AUDIT_LOGS: 'ADM-005',
    UPLOAD_PROFILES: 'ADM-006',
    BILLING_SETTINGS: 'ADM-007',
    VENDOR_IMPORT: 'ADM-008',
    CATALOG_SETTINGS: 'ADM-009',
    COST_BREAKDOWN: 'ADM-010',
    ADD_USER_MODAL: 'ADM-001M1',
    EDIT_USER_MODAL: 'ADM-001M2',
    PERMISSIONS_MODAL: 'ADM-002M1'
  },

  // Settings & Configuration
  SETTINGS: {
    GENERAL: 'SET-001',
    BUSINESS_INFO: 'SET-002',
    TAX_RATES: 'SET-003',
    RATE_SCHEDULER: 'SET-004',
    NOTIFICATIONS: 'SET-005',
    INTEGRATIONS: 'SET-006'
  },

  // Rate Management
  RATES: {
    GOLD_RATE: 'RATE-001',
    DOLLAR_RATE: 'RATE-002',
    MANUAL_ENTRY: 'RATE-003',
    RATE_HISTORY: 'RATE-004'
  },

  // Gold Schemes & Installments
  SCHEMES: {
    MANAGEMENT: 'SCH-001',
    ENROLLMENT: 'SCH-002',
    PAYMENT_ENTRY: 'SCH-003',
    DASHBOARD: 'SCH-004',
    REDEMPTION: 'SCH-005',
    REPORTS: 'SCH-006',
    CUSTOMER_SELECTION_MODAL: 'SCH-002M1',
    PAYMENT_SCHEDULE_MODAL: 'SCH-002M2',
    PAYMENT_CONFIRMATION_MODAL: 'SCH-003M1',
    REDEMPTION_CONFIRMATION_MODAL: 'SCH-005M1'
  },

  // Utilities & Tools
  UTILITIES: {
    CALCULATOR: 'UTL-001',
    RATE_CONVERTER: 'UTL-002',
    WEIGHT_CONVERTER: 'UTL-003',
    BACKUP_TOOL: 'UTL-004',
    DATA_SYNC: 'UTL-005',
    EXHIBITION_RECONCILIATION: 'UTL-006',
    BARCODE_GENERATOR: 'UTL-007',
    INVENTORY_UPLOAD: 'UTL-008',
    MISSING_IMAGES: 'UTL-009',
    CUSTOMER_CATALOG: 'UTL-010'
  },

  // Inventory Management (Upload)
  UPLOAD: {
    UPLOAD_INVENTORY: 'UPL-001'
  },

  // Shared / Public Views
  SHARED: {
    INVOICE_VIEW: 'SHR-001'
  },

  // Error & System Pages
  SYSTEM: {
    ERROR_404: 'SYS-404',
    ERROR_500: 'SYS-500',
    ACCESS_DENIED: 'SYS-403',
    MAINTENANCE: 'SYS-503',
    LOADING: 'SYS-001'
  }
};

// Helper function to get screen info
export const getScreenInfo = (screenId) => {
  // Find the screen ID in the nested structure
  for (const [category, screens] of Object.entries(SCREEN_IDS)) {
    for (const [screenName, id] of Object.entries(screens)) {
      if (id === screenId) {
        return {
          id: screenId,
          category,
          screenName,
          isModal: screenId.includes('M'),
          categoryCode: screenId.split('-')[0],
          screenNumber: screenId.split('-')[1]
        };
      }
    }
  }
  return null;
};

// Helper function to validate screen ID format
export const isValidScreenId = (screenId) => {
  const pattern = /^[A-Z]{2,4}-\d{3}(M\d+)?$/;
  return pattern.test(screenId);
};

// Get all screen IDs as a flat array
export const getAllScreenIds = () => {
  const ids = [];
  for (const category of Object.values(SCREEN_IDS)) {
    ids.push(...Object.values(category));
  }
  return ids;
};

// Screen versions — bump a screen's entry here when making visible changes to that screen
export const SCREEN_VERSIONS = {
  // Authentication
  'AUTH-001': 'v1.0', 'AUTH-002': 'v1.0', 'AUTH-003': 'v1.0', 'AUTH-004': 'v1.0', 'AUTH-005': 'v1.0',
  // Dashboard
  'DASH-001': 'v1.0', 'DASH-002': 'v1.0', 'DASH-003': 'v1.0',
  // Inventory
  'INV-001': 'v1.0', 'INV-002': 'v1.0', 'INV-003': 'v1.0', 'INV-004': 'v1.0', 'INV-005': 'v1.0',
  // Categories
  'CAT-001': 'v1.0', 'CAT-002': 'v1.0', 'CAT-003': 'v1.0', 'CAT-004': 'v1.0', 'CAT-005': 'v1.0',
  // Materials
  'MAT-001': 'v1.0', 'MAT-002': 'v1.0', 'MAT-003': 'v1.0', 'MAT-004': 'v1.0',
  // Vendors
  'VEN-001': 'v1.0', 'VEN-002': 'v1.0', 'VEN-003': 'v1.0', 'VEN-004': 'v1.0',
  'VEN-005': 'v1.0', 'VEN-006': 'v1.0',
  // Billing
  'BILL-001': 'v1.0', 'BILL-002': 'v1.0', 'BILL-003': 'v1.0', 'BILL-004': 'v1.0',
  'BILL-005': 'v1.0', 'BILL-006': 'v1.0', 'BILL-007': 'v1.0', 'RET-001': 'v1.0',
  // Estimates
  'EST-001': 'v1.0', 'EST-002': 'v1.0', 'EST-003': 'v1.0', 'EST-004': 'v1.0',
  // Customers
  'CUST-001': 'v1.0',
  // Reports
  'REP-001': 'v1.0', 'REP-002': 'v1.0', 'REP-003': 'v1.0', 'REP-004': 'v1.0',
  'REP-005': 'v1.0', 'REP-006': 'v1.0', 'REP-007': 'v1.0', 'REP-008': 'v1.0',
  // Administration
  'ADM-001': 'v1.0', 'ADM-002': 'v1.0', 'ADM-003': 'v1.0', 'ADM-004': 'v1.0',
  'ADM-005': 'v1.0', 'ADM-006': 'v1.0', 'ADM-007': 'v1.0', 'ADM-008': 'v1.0', 'ADM-009': 'v1.0',
  'ADM-010': 'v1.0',
  // Settings
  'SET-001': 'v1.0', 'SET-002': 'v1.0', 'SET-003': 'v1.0', 'SET-004': 'v1.0',
  'SET-005': 'v1.0', 'SET-006': 'v1.0',
  // Rates
  'RATE-001': 'v1.0', 'RATE-002': 'v1.0', 'RATE-003': 'v1.0', 'RATE-004': 'v1.0',
  // Schemes
  'SCH-001': 'v1.0', 'SCH-002': 'v1.0', 'SCH-003': 'v1.0', 'SCH-004': 'v1.0',
  'SCH-005': 'v1.0', 'SCH-006': 'v1.0',
  // Utilities
  'UTL-001': 'v1.0', 'UTL-002': 'v1.0', 'UTL-003': 'v1.0', 'UTL-004': 'v1.0',
  'UTL-005': 'v1.0', 'UTL-006': 'v1.0', 'UTL-007': 'v1.0', 'UTL-008': 'v1.0',
  'UTL-009': 'v1.0', 'UTL-010': 'v1.0',
  // Upload
  'UPL-001': 'v1.0',
  // Shared
  'SHR-001': 'v1.0',
};

export default SCREEN_IDS;
